export const EDIT_SUCCESS = 'Автомобиль обновлен';
export const EDIT_ERROR = 'Не удалось обновить автомобиль';

export const DELETE_SUCCESS = 'Автомобиль удален';
export const DELETE_ERROR = 'Не удалось удалить автомобиль';
